import React from "react"
import heroImg from "../../../images/devices.svg";

const HeroImage = () => (
  <img className="is-bottom" alt="hero" src={heroImg}/>

)
export default HeroImage
